
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/hugg",
      function () {
        return require("private-next-pages/case-study/hugg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/hugg"])
      });
    }
  